/**
 * Resolve the API base URL for the hosted checkout SPA (bd bj9).
 *
 * The SPA is served from a different origin than the API in every deployed
 * environment, so the base URL is env-driven via the Vite build-time var
 * `VITE_API_BASE_URL`. There is deliberately NO localhost / same-origin
 * fallback in a production build: a missing var fails loud at module load
 * rather than silently fetching HTML (a 404 page) and surfacing later as an
 * opaque JSON parse error.
 *
 * Precedence:
 *   1. `VITE_API_BASE_URL` — used verbatim (trailing slash trimmed) in any mode.
 *   2. Dev mode, no override — empty string; the Vite dev server proxies
 *      `/v1` to the local API (see `vite.config.ts`).
 *   3. Production build, no override — throw.
 *
 * @param env The relevant slice of `import.meta.env`. Injected for testability.
 */
export function resolveApiBaseUrl(env: {
  PROD?: boolean;
  VITE_API_BASE_URL?: string;
}): string {
  const override = env.VITE_API_BASE_URL?.trim();
  if (override) return override.replace(/\/+$/, '');
  if (env.PROD) {
    throw new Error(
      'VITE_API_BASE_URL is not set. A production checkout build must point at ' +
        'the API origin (e.g. https://api.dev.nextcheckout.dev); refusing to ' +
        'fall back to same-origin, which would fetch HTML instead of JSON.',
    );
  }
  return '';
}
